module.exports = __webpack_public_path__ + "media/images/clothes1-efb9d1d722afc56aa45046f38c1915cf.jpg";